import './style.scss';

import Alpine from 'alpinejs';

import '../../../../Packages/Plugins/BetterEmbed.NeosEmbed/Resources/Private/Assets/Main';

// custom
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import './src/scripts/helpers/vh';
import 'share-api-polyfill';
import smoothscroll from 'smoothscroll-polyfill';
import AirDatepicker from "air-datepicker";
import LocaleDE from "air-datepicker/locale/de";
import "air-datepicker/air-datepicker.css";
import Masonry from "masonry-layout";

import Article from './src/scripts/component/article';
import Breadcrumbs from "./src/scripts/component/breadcrumbs";
import EventPage from './src/scripts/component/event-page';
import Slider from './src/scripts/component/slider';
import Search from './src/scripts/component/search';
import BusinessUnitSelect from "./src/scripts/component/business-unit-select";
import Modal from "./Fusion/Presentation/Organism/Modal/Modal";
import Dropdown from "./src/scripts/component/dropdown";
import Header from "./Fusion/Presentation/Organism/Header/Header";
import FieldWithFloatingPlaceholder from "./src/scripts/component/field-with-floating-placeholder";
import FormHandler from "./src/scripts/component/forms";
import './src/scripts/registration'
import Lightbox from "./src/scripts/component/lightbox";
import HashScrolling from "./src/scripts/hash-scrolling";

// Initialize Alpine.js
window.Alpine = Alpine;
window.user = null; // TODO: Refactor to AlpineJS-only and rewrite the masonary logic
document.addEventListener('DOMContentLoaded', async () => {
    if (window['IS_LOGGED_IN'] === true && !document.body.classList.contains('neos-backend')) {
        const response = await fetch('/service/user', {
            credentials: 'include'
        })
        const user = await response.json()
        window.user = user;
        Alpine.store('initialized', true)
        Alpine.store('user', user)
    }
    Alpine.start()
})

function setFontSize(fontSize) {
    localStorage.setItem('fontSize', fontSize);
    if (fontSize === 14) {
        document.body.classList.remove('body--use-larger-font');
    } else {
        document.body.classList.add('body--use-larger-font');
    }
    document.body.style.setProperty('--font-base', fontSize + 'px');
}

// init application
class App {
    constructor() {
        // responsive font size
        setFontSize(localStorage.getItem('fontSize')*1 || 14);
        const decreaseButton = document.querySelector('.header__font-decrease-button');
        if (decreaseButton) {
            decreaseButton.addEventListener('click', () => {
                let fontSize = localStorage.getItem('fontSize') * 1 || 14;
                setFontSize(Math.max(fontSize - 2, 14));
            });
        }
        const increaseButton = document.querySelector('.header__font-increase-button');
        if (increaseButton) {
            increaseButton.addEventListener('click', () => {
                let fontSize = localStorage.getItem('fontSize') * 1 || 14;
                setFontSize(Math.min(fontSize + 2, 24));
            });
        }

        // "hover" effect for touch devices
        let elements = document.querySelectorAll('.link__list a, .article__author a, .article__content a, .header__logo, .link-box');
        Array.prototype.forEach.call(elements, (el) => {
            el.addEventListener('touchstart', (e) => {
                e.currentTarget.focus({preventScroll: true})
            });

            el.addEventListener('touchend', (e) => {
                e.currentTarget.blur({preventScroll: true})
            });
        });

        // sliders init
        Slider.init();

        (new Article()).initAll();

        new EventPage().init();
        new FormHandler().init();
        new BusinessUnitSelect();

        Breadcrumbs.init();
        Search.init();
        FieldWithFloatingPlaceholder.init();
        smoothscroll.polyfill();


        let options = {
            language: 'de',
            autoClose: true,
            locale: LocaleDE,
            keyboardNav: false,
            isMobile: window.innerWidth < 768,
            altFieldDateFormat: (date) => {
                let day = date.getDate();
                let month = date.getMonth() + 1;
                let year = date.getFullYear();
                day = day < 10 ? '0' + day : day;
                month = month < 10 ? '0' + month : month;
                return day + month + year;
            }
        };

        let datepickers = Array.from(document.querySelectorAll('input.datepicker-field'));

        datepickers.forEach(el => {
            if (!el.closest('.datepicker-form__field')) return;

            let picker = new AirDatepicker(el, {
                altField: el.closest('.datepicker-form__field').querySelector('.datepicker-field__value-container'),
                ...options
            });

            let strToDate = (dateStr) => {
                let date = dateStr.split('.');
                let day = date[0];
                let month = parseInt(date[1]) - 1;
                let year = date[2];

                return new Date(+year, +month, +day);
            }

            el.addEventListener('input', (e) => {
                let len = el.value.length;

                if (e.keyCode === 13 || len === 10) {
                    let date = strToDate(e.target.value);

                    if (date) {
                        picker.selectDate(date);
                        picker.setFocusDate(date);
                    }
                }

                if (e.keyCode < 48 || e.keyCode > 57 || len > 9) {
                    e.preventDefault();
                }
            });
        });

        Modal.init();
        Dropdown.init();
        Header.init();

        function filterArticleList(callAfterFilter) {
            let grid = document.querySelector('.articles__list');
            if (!grid) {
                return;
            }
            // If we are in backend, we render the list directly, skipping the filtering
            if (document.body.classList.contains('neos-backend')) {
                callAfterFilter();
                return;
            }
            // If we are logged in, we wait for the user information to be fetched
            if (window.IS_LOGGED_IN === true && !window.user) {
                setTimeout(filterArticleList, 300, callAfterFilter);
                return;
            }
            Array.from(document.querySelectorAll('.articles__list .article')).forEach((el) => {
                const config = JSON.parse(el.dataset.config);
                let isAllowed = true;
                if (config?.allowedGroups && config.allowedGroups.length > 0) {
                    isAllowed = config.allowedGroups.reduce((accumulator, allowedGroup) => {
                        return accumulator || window.user.groups.includes(allowedGroup)
                    }, false)
                }
                if (!isAllowed) {
                    el.remove();
                }
            });
            callAfterFilter();
        }
        function createArticleMasonry() {
            let grid = document.querySelector('.articles__list');
            if (!grid) {
                return;
            }
            if (window.innerWidth === 0) { // webview isn't fully initialized yet
                setTimeout(createArticleMasonry, 100);
            } else if (window.articleList && window.innerWidth > 0 && window.innerWidth <= 767) {
                window.articleList.destroy()
                window.articleList = null
            } else if (!window.articleList && window.innerWidth > 767) {
                window.articleList = new Masonry(grid, {
                    itemSelector: '.article',
                    gutter: 0,
                    resize: true
                });
            }
            grid.classList.add('articles__list--initialized')
        }
        // TODO refactor
        filterArticleList(createArticleMasonry);
        window.addEventListener('resize', createArticleMasonry);

        // data-placeholder
        const inputElementsWithDataPlaceholder = document.querySelectorAll('input[data-placeholder]')
        inputElementsWithDataPlaceholder.forEach(el => {
            el.setAttribute('placeholder', el.dataset.placeholder.replace('\\', ''))
        })

        let fileInputs = document.querySelectorAll('[type=file]');
        Array.prototype.forEach.call(fileInputs, el => {
            el.addEventListener('change', () => {
                let fileNameElement = el.parentNode.querySelector('.file-name');
                let clearButton = el.parentNode.querySelector('.file-name__clear');

                if (el.files) {
                    fileNameElement.innerHTML = (el.files[0].name)
                    fileNameElement.classList.add('file-name--is-active')
                    clearButton.classList.add('visible')
                } else {
                    fileNameElement.innerHTML = fileNameElement.dataset.placeholder
                    fileNameElement.classList.remove('file-name--is-active')
                    clearButton.classList.remove('visible')
                }

                clearButton.addEventListener('click', () => {
                    el.value = '';
                    fileNameElement.innerHTML = fileNameElement.dataset.placeholder;
                    fileNameElement.classList.remove('file-name--is-active');
                    clearButton.classList.remove('visible')
                })
            });
        });

        // Hide navigation on mobile when input is focused
        const navigation = document.querySelector('.header__menu')
        if (navigation) {
            document.addEventListener('focus', function (event) {
                if (event.target.tagName.toLowerCase() === 'input') {
                    navigation.classList.add('header__menu--hidden')
                }
            }, true)
            document.addEventListener('focusout', function (event) {
                if (event.target.tagName.toLowerCase() === 'input') {
                    navigation.classList.remove('header__menu--hidden')
                }
            }, true)
        }

        document.addEventListener('focusout', function(event) {
            const formInput = event.target
            if (formInput.tagName === 'INPUT' || formInput.tagName === 'SELECT' || formInput.tagName === 'TEXTAREA') {
                const isValid = formInput.checkValidity()
                if (!isValid) {
                    formInput.classList.add('invalid')
                } else {
                    formInput.classList.remove('invalid')
                }
            }
        })

        document.addEventListener('invalid', function(event) {
            const formInput = event.target
            if (formInput.tagName === 'INPUT' || formInput.tagName === 'SELECT' || formInput.tagName === 'TEXTAREA') {
                formInput.classList.add('invalid')
            }
        }, true)

        // password input type toggle handler
        let passwordInputs = document.querySelectorAll('[type=password]');
        if (passwordInputs) {
            Array.prototype.forEach.call(passwordInputs, el => {
                let toggleButton = el.parentNode.querySelector('.password-toggle');

                if (!toggleButton) return;
                toggleButton.addEventListener('click', () => {
                    if (el.type === 'password') {
                        el.type = 'text';
                        toggleButton.classList.add('password-toggle--is-active');
                    } else {
                        el.type = 'password';
                        toggleButton.classList.remove('password-toggle--is-active');
                    }
                });
            });
        }

        document.addEventListener('click', function(e) {
            const linkElement = e.target.closest('a');
            if (linkElement && linkElement.href) {
                const url = new URL(linkElement.href);

                // Do nothing if the link opens in a separate window
                if (linkElement.getAttribute('target') === '_blank') {
                    return;
                }

                // Do nothing if it is an external link, as they open in a separate window
                if (url.host !== window.location.host) {
                    return;
                }

                // Do nothing if link is on same page
                if (url.pathname === window.location.pathname) {
                    return;
                }

                document.body.classList.add('body--is-closing')

                const currentUrl = new URL(window.location)
                const referrerUrl = document.referrer !== '' ? new URL(document.referrer) : null
                // Handle back link button clicks
                if (linkElement.classList.contains('link-back') && (referrerUrl && referrerUrl.host === currentUrl.host && history.length > 1)) {
                    history.back()
                    e.preventDefault()
                } else if (linkElement.classList.contains('link-back')) {
                    window.location = '/'
                    e.preventDefault()
                }
            }
        })

        document.addEventListener('submit', function() {
            document.body.classList.add('body--is-closing')
        })

        window.addEventListener('pageshow', () => {
            document.body.classList.remove('body--is-closing');
        });

        Lightbox.init();
        HashScrolling.init();
    }
}

new App();
